"use client";

import { motion, Variants } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import { useLanguage } from "@/components/context/LanguageContext";
import type { Projects } from "@/types/project";
import useSWR from "swr";
import {
    Card,
    CardAction,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"



// Framer Motion Variants with delay per card
const cardVariant: Variants = {
    hidden: {
        opacity: 0,
        y: 30,
        scale: 0.95,
    },
    visible: (i: number) => ({
        opacity: 1,
        y: 0,
        scale: 1,
        transition: {
            duration: 0.6,
            delay: i * 0.2,
            ease: "easeOut",
        },
    }),
};


const Project = () => {
    const fetcher = (url: string) => fetch(url).then(res => res.json());
    const { data, error, isLoading } = useSWR('/api/project', fetcher, { suspense: false });
    // console.log(data);
    const projects: Projects[] = data?.projects || [];
    const { language } = useLanguage();

    return (
        <div className="w-full px-4 pb-10 bg-white bor">
            <div className={`grid ${projects.length > 1 ? "md:grid-cols-2 xl:grid-cols-3" : "grid-cols-1"} gap-6 mb-8 `}>
                {projects.map((project, index) => {
                    const title =
                        language === "en"
                            ? project?.title?.en
                            : project?.title?.id;
                    return (
                        <motion.div
                            key={project.id}
                            custom={index}
                            variants={cardVariant}
                            initial="hidden"
                            whileInView="visible"
                            whileHover={{ scale: 1.03 }}
                            whileTap={{ scale: 0.98 }}
                            viewport={{ once: true, amount: 0.3 }}
                            className="max-w-xl w-full mx-auto bor"
                        >
                            <Card className="overflow-hidden rounded-md shadow-md">

                                {/* IMAGE */}
                                <div className="relative w-full h-[200px]">
                                    <Image
                                        src={project?.headerImage}
                                        alt="Project Image"
                                        fill
                                        className="object-cover"
                                    />
                                    <p className="absolute top-2 right-2 text-xs text-white bg-green-600/80 px-2 py-1 rounded-lg">
                                        {project.status}
                                    </p>
                                </div>

                                {/* CONTENT */}
                                <CardHeader className="text-center">
                                    <CardTitle className="text-lg text-gray-800">
                                        {language === "en" ? project.title.en : project.title.id}
                                        {title?.length < 41 && (
                                            <div><br /></div>
                                        )}
                                    </CardTitle>
                                </CardHeader>

                                {/* FOOTER */}
                                <CardFooter className="">
                                    {/* {project.content.length === 0 ? (
                                        <Link
                                            href={`/profile/portfolio/${project.id}`}
                                            className="w-full text-center bg-gray-100 text-[#005b96] py-3 hover:bg-gray-200 transition"
                                        >
                                            Learn More
                                        </Link>
                                    ) : (
                                        <button
                                            disabled
                                            className="w-full bg-gray-100 text-gray-400 py-3 cursor-not-allowed"
                                        >
                                            Learn More
                                        </button>
                                    )} */}
                                    <Link
                                            href={`/profile/portfolio/${project.id}`}
                                            className="w-full text-center bg-gray-100 text-[#005b96] py-3 hover:bg-gray-200 transition"
                                        >
                                            Learn More
                                        </Link>
                                </CardFooter>
                            </Card>
                        </motion.div>
                    )
                })}
            </div>

            <div className="flex justify-center">
                <Link
                    href="/profile/portfolio"
                    className="rounded-md border border-[#005b96] text-md font-medium text-[#005b96] px-4 py-2 hover:bg-[#005b96] hover:text-white transition-all"
                >
                    {language === "en" ? "View All Projects" : "Lihat Semua Proyek"}
                </Link>
            </div>
        </div>
    );
};

export default Project;
